import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-step-review',
  templateUrl: './step-review.component.html',
  styleUrls: ['./step-review.component.less']
})
export class StepReviewComponent implements OnInit {
  @Input() reviewTitle: string;

  constructor() { }

  ngOnInit(): void {
  }

}
